module.exports = __webpack_public_path__ + "6682c3d6db25538bd064c1c4f4da489e.pdf";